module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/sec_problem_img02-768f6a6bc859aa88b093a2adaa0da67b.svg";